import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./LandingScreen.css";
import { API_BASE_URL } from "../config";
import { Link } from "react-router-dom";

const LandingScreen = ({ setCredits, setUserName, setUserEmail }) => {
  const navigate = useNavigate();

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userId, setUserId] = useState(localStorage.getItem("user_id") || null);
  const [problem, setProblem] = useState("");
  const [placeholderIndex, setPlaceholderIndex] = useState(0);
  const [showCookiesBanner, setShowCookiesBanner] = useState(
    localStorage.getItem("cookiesAccepted") !== "true"
  );

  const placeholders = [
    "Describe your issue here...",
    "I have a startup idea, but don’t know how to start.",
    "I want to register my company and build a strong brand.",
    "Need help with website, social media, and marketing.",
    "I want to automate my business processes.",
    "How can I grow my sales without handling all the backend?",
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setPlaceholderIndex((prevIndex) => (prevIndex + 1) % placeholders.length);
    }, 1500);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const savedProblem = localStorage.getItem("user_problem");
    if (savedProblem) setProblem(savedProblem);

    const initialize = async () => {
      if (!userId) return;

      try {
        const res = await axios.get(`${API_BASE_URL}/get-user-email/${userId}`);
        setIsLoggedIn(true);
        setUserName(res.data.name);
        setUserEmail(res.data.email);
        await fetchCredits(userId);

        const chatRes = await axios.get(
          `${API_BASE_URL}/has-started-chat/${userId}`
        );

        if (chatRes.data.has_started && userId !== "admin") {
          navigate("/chat");
        }
      } catch {
        localStorage.clear();
        setIsLoggedIn(false);
        setUserId(null);
        setUserName("");
        setUserEmail("");
      }
    };

    initialize();
  }, [userId, navigate, setUserName, setUserEmail]);

  const fetchCredits = useCallback(
    async (uid) => {
      try {
        const res = await axios.get(`${API_BASE_URL}/get-credits/${uid}`);
        setCredits(res.data.credits);
        setUserName(res.data.name);
        setUserEmail(res.data.email);
      } catch (err) {
        console.error("[fetchCredits] Failed:", err);
      }
    },
    [setCredits, setUserName, setUserEmail]
  );

  const handleLogout = () => {
    localStorage.clear();
    setIsLoggedIn(false);
    setUserId(null);
    setUserEmail("");
    setUserName("");
    alert("Logged out successfully!");
  };

  const handleGetStarted = async () => {
    if (isLoggedIn && userId) {
      if (problem) {
        try {
          await axios.post(`${API_BASE_URL}/save-user-problem`, {
            user_id: userId,
            problem: problem,
          });
        } catch (err) {
          console.error("Failed to save problem:", err);
        }
      }
      navigate("/form");
    } else {
      alert("🚫 Please sign in or sign up to get started.");
      navigate("/signup");
    }
  };

  const acceptCookies = () => {
    localStorage.setItem("cookiesAccepted", "true");
    setShowCookiesBanner(false);
  };

  return (
    <div className="landing-screen">
      <div className="glow-highlight"></div>
      <div className="branding-left">STRATXCEL.AI</div>

      {isLoggedIn && userId === "admin" && (
        <button className="admin" onClick={() => navigate("/admin")}>
          Admin Panel
        </button>
      )}

      <div className="top-right-buttons">
        {isLoggedIn ? (
          <button onClick={handleLogout}>Logout</button>
        ) : (
          <button onClick={() => navigate("/signin")}>Log In</button>
        )}
      </div>

      <h1>BUSINESS CONSULTANCY MADE EASY</h1>
      <p>
        Let’s get your business sorted — A to Z — while you focus on your vision
      </p>

      <textarea
        className="chat-input-container"
        value={problem}
        onChange={(e) => {
          const val = e.target.value;
          setProblem(val);
          localStorage.setItem("user_problem", val);
        }}
        placeholder={placeholders[placeholderIndex]}
        rows="6"
        required
      />

      <button onClick={handleGetStarted}>Get Started</button>

      {/* ✅ Cookies Banner */}
      {showCookiesBanner && (
        <div className="cookies-banner">
          <p>
            StratXcel.Ai can make mistakes. Check important info. See Cookie
            Preferences.{" "}
            <Link to="/privacy" target="_blank" rel="noreferrer">
              Privacy Policy
            </Link>{" "}
            and{" "}
            <Link to="/terms" target="_blank" rel="noreferrer">
              Terms & Conditions
            </Link>
            .
          </p>
          <button onClick={acceptCookies}>Accept</button>
        </div>
      )}
    </div>
  );
};

export default LandingScreen;
